'use client'

import { ImageDithering } from '@paper-design/shaders-react'
import { useEffect, useRef, useState } from 'react'
import { getCdnPath } from '~/lib/utils'

interface LazyImageDitheringProps {
  imagePath: string
  className?: string
}

export function LazyImageDithering({ imagePath, className }: LazyImageDitheringProps) {
  const [shouldRender, setShouldRender] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const container = containerRef.current
    if (!container)
      return

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Render canvas when element enters viewport, unload when it leaves
          if (entry.isIntersecting) {
            setShouldRender(true)
          }
          else {
            setShouldRender(false)
          }
        })
      },
      {
        rootMargin: '200px', // Start loading 200px before element enters viewport
        threshold: 0, // Trigger as soon as any part becomes visible
      },
    )

    observer.observe(container)

    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <div ref={containerRef} className={className || 'absolute inset-0 z-0 size-full'}>
      {shouldRender && (
        <ImageDithering
          className="absolute inset-0 z-0 size-full"
          image={getCdnPath(imagePath)}
          originalColors
          type="8x8"
          pxSize={1}
          colorSteps={5}
          fit="cover"
        />
      )}
    </div>
  )
}
